import { useCallback } from "react"
import { API_ENDPOINTS } from "../../../api/endpoints"
import { useApi } from "../../../hooks/useApi"

export const useAssignRoleToUserAuth0 = () => {
  const api = useApi()

  return useCallback(
    (userId: string, roleId: string): Promise<unknown> =>
      api.post(
        `${API_ENDPOINTS.BASE}auth0/users/${roleId}/roles`,
        { users: [userId] },
        { errorMessage: "Error al asignar el rol en Auth0" },
      ),
    [api],
  )
}
